<template>
    <div class="dap-filter-item">
        <div class="sub-title flex-normal" v-if="!hideName">
            {{ filterOption.name }}
            <el-tooltip effect="light" placement="top" popper-class="dap-light-popper" v-if="filterOption.tip">
                <div slot="content">
                    <div class="c-666 f12" v-html="filterOption.tip" style="line-height: 17px"></div>
                </div>
                <dap-icon-svg icon-class="shuoming" class="icon-hover f18" style="z-index: 100;color: #C0C4CC;flex: 0 0 18px"></dap-icon-svg>
            </el-tooltip>
        </div>

        <el-select
            v-if="type === 'single'" popper-class="global-filter-select-popper"
            class=""  v-model="selectedValue" :clearable="filterOption.clearable || filterOption.clearable === undefined"
            :style="{width: `${width}px`}"
            :size="size"
            :value-key="propsMapper.value"
            :disabled="filterOption.disabled" filterable
            :placeholder="filterOption.placeholder || '请选择'">
            <el-option
                v-for="item in filterOption.dataList" :key="item[propsMapper.value]" :value="item"
                :label="item[propsMapper.label]"
            ></el-option>
        </el-select>

        <DapMultiSelectPull
            v-else-if="type === 'multi'"
            :style="{width: `${width}px`}"
            class="" ref="multiSelect"
            :size="size" :loadMore="handleLoadMore"
            v-bind="filterOption" :resultList="selectList" :hideBorder="hideBorder"
            @change="handleChangeSelect" @delete="handleDelete">
        </DapMultiSelectPull>

        <MultiSelectBarForFilter
            v-else-if="type === 'multiModal'"
            :style="{width: `${width}px`}"
            class="" ref="multiSelectWithModal" :filterOption="filterOption"
            :size="size" :loadMore="handleLoadMore" :title="filterOption.name"
            v-bind="filterOption" :resultList="selectList" :hideBorder="hideBorder"
            :excludeSelected="excludeSelected"
            @change="handleChangeSelect" @delete="handleDelete">
        </MultiSelectBarForFilter>

        <div v-else-if="type === 'slot'" >
            <slot :name="filterOption.key"></slot>
        </div>


    </div>
</template>

<script>
    // import DapMultiSelectBar from '../../../base-selector/src/MultiSelectBar';
    import MultiSelectBarForFilter from './MultiSelectBarForFilter';
    import DapMultiSelectPull from '../../../base-selector/src/MultiSelectPull';
    import DapIconSvg from '../../../icon-svg/src/IconSvg';
    export default {
        name: 'ItemFilter',
        components: {
            // DapMultiSelectBar,
            MultiSelectBarForFilter,
            DapMultiSelectPull,
            DapIconSvg
        },
        props: {
            filterOption: {
                type: Object,
                default: () => {},
            },
            selectedDict: {
                type: Object,
                default: () => {},
            },
            hideName: {
                type: Boolean,
                default: false,
            },
            hideBorder: {
                type: Boolean,
                default: false,
            },
            width: {
                type: Number,
                default: 200,
            },
            size: {
                type: String,
                default: 'mini',
            },
        },
        data () {
            return {
                search: '',
            };
        },
        computed: {
            type () {
                return this.filterOption.type;
            },
            key () {
                return this.filterOption.key;
            },
            excludeSelectedKey () {
                return this.filterOption.excludeSelectedKey;
            },
            propsMapper () {
                return this.filterOption.propsMapper || { value: 'value' , label: 'label' };
            },
            selectList () {
                if (!this.selectedDict[this.key]) {
                    return [];
                }
                return this.selectedDict[this.key];
            },
            excludeSelected () {
                if (!this.selectedDict[this.excludeSelectedKey]) {
                    return false;
                }
                return this.selectedDict[this.excludeSelectedKey];
            },
            selectedValue: {
                get () {
                    if (!this.selectedDict[this.key]) {
                        return {};
                    }
                    return this.selectedDict[this.key];
                },
                set (val) {
                    if (val){
                        this.$emit('setResult', { selectType: this.key, value: val});
                    } else {
                        this.$emit('setResult', { selectType: this.key, value: {}});
                    }
                }
            }
        },
        methods: {
            handleChangeSelect (res, exclude) {
                // 多选弹框并且开启了排除功能
                const excludeSelectedKey = this.type === 'multiModal' && this.filterOption.showExcludeSelected ? this.excludeSelectedKey : '';
                this.$emit('setResult',
                    { selectType: this.key, value: res},
                    excludeSelectedKey,
                    exclude
                );
            },
            handleDelete () {
                // this.$emit('setResult', { selectType: this.key, value: []});
            },
            handleLoadMore (params) {
                if (!this.filterOption.loadMore) {
                    return null;
                }
                // 把自身的key排除掉,不需要参与外部的param合并
                const { [this.key]: key, ...others  } = this.selectedDict;
                return this.filterOption.loadMore({ ...params, ...others });
            }
        }
    };
</script>


<style lang="scss">
.dap-filter-panel .dap-filter-item {
    display: flex;
    align-items: center;
    font-size: 12px;
    height: 30px;
    .sub-title {
        color: #333333;
        font-size: 12px;
        margin-right: 10px;
        width: 75px;
        text-align: right;
        justify-content: flex-end;
    }
    .el-input--small {
        font-size: 12px;
    }
}
</style>
